import { render, staticRenderFns } from "./ParkingSpot.vue?vue&type=template&id=5158939f&scoped=true"
import script from "./ParkingSpot.vue?vue&type=script&lang=js"
export * from "./ParkingSpot.vue?vue&type=script&lang=js"
import style0 from "./ParkingSpot.vue?vue&type=style&index=0&id=5158939f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5158939f",
  null
  
)

export default component.exports